/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';
export const UtrechtArticle = /*@__PURE__*/ defineContainer('utrecht-article', undefined);
export const UtrechtBadgeCounter = /*@__PURE__*/ defineContainer('utrecht-badge-counter', undefined, [
    'value',
    'max',
    'locale'
]);
export const UtrechtBadgeData = /*@__PURE__*/ defineContainer('utrecht-badge-data', undefined);
export const UtrechtBadgeStatus = /*@__PURE__*/ defineContainer('utrecht-badge-status', undefined, [
    'status'
]);
export const UtrechtBreadcrumb = /*@__PURE__*/ defineContainer('utrecht-breadcrumb', undefined, [
    'json',
    'variant'
]);
export const UtrechtButton = /*@__PURE__*/ defineContainer('utrecht-button', undefined, [
    'busy',
    'disabled',
    'type',
    'utrechtRequestReset',
    'utrechtRequestSubmit'
]);
export const UtrechtCheckbox = /*@__PURE__*/ defineContainer('utrecht-checkbox', undefined, [
    'disabled',
    'readOnly',
    'checked',
    'value',
    'utrechtBlur',
    'utrechtChange',
    'utrechtFocus',
    'utrechtInput'
], 'checked', 'utrechtInput');
export const UtrechtContactCardTemplate = /*@__PURE__*/ defineContainer('utrecht-contact-card-template', undefined);
export const UtrechtDigidButton = /*@__PURE__*/ defineContainer('utrecht-digid-button', undefined, [
    'type'
]);
export const UtrechtDigidLogo = /*@__PURE__*/ defineContainer('utrecht-digid-logo', undefined);
export const UtrechtDocument = /*@__PURE__*/ defineContainer('utrecht-document', undefined);
export const UtrechtEherkenningLogo = /*@__PURE__*/ defineContainer('utrecht-eherkenning-logo', undefined);
export const UtrechtEidasLogo = /*@__PURE__*/ defineContainer('utrecht-eidas-logo', undefined);
export const UtrechtFormFieldCheckbox = /*@__PURE__*/ defineContainer('utrecht-form-field-checkbox', undefined, [
    'label',
    'disabled',
    'checked',
    'invalid',
    'required',
    'utrechtBlur',
    'utrechtChange',
    'utrechtFocus',
    'utrechtInput'
], 'checked', 'utrechtInput');
export const UtrechtFormFieldDescription = /*@__PURE__*/ defineContainer('utrecht-form-field-description', undefined, [
    'status'
]);
export const UtrechtFormFieldTextarea = /*@__PURE__*/ defineContainer('utrecht-form-field-textarea', undefined, [
    'disabled',
    'invalid',
    'readOnly',
    'placeholder',
    'required',
    'value',
    'utrechtBlur',
    'utrechtChange',
    'utrechtFocus',
    'utrechtInput'
], 'value', 'utrechtInput');
export const UtrechtFormFieldTextbox = /*@__PURE__*/ defineContainer('utrecht-form-field-textbox', undefined, [
    'autoComplete',
    'disabled',
    'invalid',
    'min',
    'max',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'type',
    'value',
    'utrechtBlur',
    'utrechtChange',
    'utrechtFocus',
    'utrechtInput'
], 'value', 'utrechtInput');
export const UtrechtFormToggle = /*@__PURE__*/ defineContainer('utrecht-form-toggle', undefined, [
    'disabled',
    'checked',
    'utrechtBlur',
    'utrechtChange',
    'utrechtFocus',
    'utrechtInput'
], 'checked', 'utrechtInput');
export const UtrechtHeading = /*@__PURE__*/ defineContainer('utrecht-heading', undefined, [
    'level'
]);
export const UtrechtHeading1 = /*@__PURE__*/ defineContainer('utrecht-heading-1', undefined);
export const UtrechtHeading2 = /*@__PURE__*/ defineContainer('utrecht-heading-2', undefined);
export const UtrechtHeading3 = /*@__PURE__*/ defineContainer('utrecht-heading-3', undefined);
export const UtrechtHeading4 = /*@__PURE__*/ defineContainer('utrecht-heading-4', undefined);
export const UtrechtHeading5 = /*@__PURE__*/ defineContainer('utrecht-heading-5', undefined);
export const UtrechtHeading6 = /*@__PURE__*/ defineContainer('utrecht-heading-6', undefined);
export const UtrechtHtmlContent = /*@__PURE__*/ defineContainer('utrecht-html-content', undefined);
export const UtrechtIconArrow = /*@__PURE__*/ defineContainer('utrecht-icon-arrow', undefined);
export const UtrechtIconCheckmark = /*@__PURE__*/ defineContainer('utrecht-icon-checkmark', undefined);
export const UtrechtIconCross = /*@__PURE__*/ defineContainer('utrecht-icon-cross', undefined);
export const UtrechtIconFacebook = /*@__PURE__*/ defineContainer('utrecht-icon-facebook', undefined);
export const UtrechtIconFilter = /*@__PURE__*/ defineContainer('utrecht-icon-filter', undefined);
export const UtrechtIconInstagram = /*@__PURE__*/ defineContainer('utrecht-icon-instagram', undefined);
export const UtrechtIconLinkedin = /*@__PURE__*/ defineContainer('utrecht-icon-linkedin', undefined);
export const UtrechtIconList = /*@__PURE__*/ defineContainer('utrecht-icon-list', undefined);
export const UtrechtIconLoupe = /*@__PURE__*/ defineContainer('utrecht-icon-loupe', undefined);
export const UtrechtIconTwitter = /*@__PURE__*/ defineContainer('utrecht-icon-twitter', undefined);
export const UtrechtIconWhatsapp = /*@__PURE__*/ defineContainer('utrecht-icon-whatsapp', undefined);
export const UtrechtIconZoomin = /*@__PURE__*/ defineContainer('utrecht-icon-zoomin', undefined);
export const UtrechtIconZoomout = /*@__PURE__*/ defineContainer('utrecht-icon-zoomout', undefined);
export const UtrechtLogo = /*@__PURE__*/ defineContainer('utrecht-logo', undefined);
export const UtrechtLogoButton = /*@__PURE__*/ defineContainer('utrecht-logo-button', undefined, [
    'type'
]);
export const UtrechtPageFooter = /*@__PURE__*/ defineContainer('utrecht-page-footer', undefined);
export const UtrechtPagination = /*@__PURE__*/ defineContainer('utrecht-pagination', undefined, [
    'links',
    'next',
    'prev',
    'currentIndex'
]);
export const UtrechtParagraph = /*@__PURE__*/ defineContainer('utrecht-paragraph', undefined, [
    'lead'
]);
export const UtrechtSeparator = /*@__PURE__*/ defineContainer('utrecht-separator', undefined);
export const UtrechtSidenav = /*@__PURE__*/ defineContainer('utrecht-sidenav', undefined, [
    'json'
]);
export const UtrechtTextbox = /*@__PURE__*/ defineContainer('utrecht-textbox', undefined, [
    'autoComplete',
    'disabled',
    'invalid',
    'min',
    'max',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'type',
    'value',
    'utrechtBlur',
    'utrechtChange',
    'utrechtFocus',
    'utrechtInput'
], 'value', 'utrechtInput');
